import { useFirestoreDoc } from "./useFirestoreDoc";
import type {
    User,
  } from "@skillscratch/shared-types";
import { useFirebaseUser } from "./useFirebaseUser";

export function useBalance(): [User | undefined, boolean, Error | undefined] {
    const user = useFirebaseUser();
    const [userData, isUserDataLoading, userDataError] = useFirestoreDoc<User>(
        () => {
          const userId = user?.uid;
          if (!userId) {
            return;
          }
          return ["user", userId];
        },
        [user],
        "onSnapshot"
      );

    return [userData, isUserDataLoading, userDataError];
}